<div [ngClass]="{'d-flex h-100': centered}" class="apply-one-style bg-transparent">
  <div [ngClass]="{'m-auto': centered}">
    <svg class="ob1-spinner-undetermined centered" viewBox="0 0 50 50" [ngStyle]="{'width': size, 'height': size}">
      <circle class="ob1-spinner-undetermined-circle" cx="25" cy="25" r="20"></circle>
    </svg>
    @if (text) {
      <p class="material-spinner-text">{{text}}</p>
    }
  </div>
</div>
